import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-location",
  "use": "icon-location-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-location\"><path d=\"M13.2 23.597a2 2 0 0 1-2.4 0C5.013 19.26 2 14.742 2 10 2 4.477 6.477 0 12 0c5.526 0 10.01 4.48 10 10.003-.008 4.74-3.02 9.255-8.8 13.594zm-1.2-1.6C17.326 18 19.993 14 20 10c.008-4.418-3.582-8-8-8a8 8 0 0 0-8 8c0 4 2.667 8 8 11.997zM12 14a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm0-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol